import request from '@/utils/request'

// 新增申请信息
export function addApply (data) {
  return request({
    url: '/mostone/speciality_apply',
    method: 'post',
    data
  })
}

// 获取验证码
export function getCode (data) {
  return request({
    url: '/mostone/speciality_apply_sms',
    method: 'post',
    data
  })
}

export function getDownUrl () {
  return request({
    url: '/mostone/latest_local_apk',
    method: 'get'
  })
}
